import React from 'react';
import Explorer from '../../data-containers/explorer';
import LocationDetails from '../../data-containers/location-details';
import FleetExplorer from '../explorer/fleet';
import withPage from './';

function DashboardPage(){
  return (
    <Explorer.Provider>
      <LocationDetails.Provider>
        <FleetExplorer />
      </LocationDetails.Provider>
    </Explorer.Provider>
  )
}

export default withPage(DashboardPage);
